var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ChatModalClient',{attrs:{"visible":_vm.visible,"chat":_vm.activeChat},on:{"close":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }